import BootstrapTable from 'react-bootstrap-table-next';
import { TableHeaderColumns, TopChannels, TopFiles, TopUsers } from '../../types/AppTypes';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Grid, GridSize } from '@material-ui/core';

interface PROPS {
  columns: TableHeaderColumns[];
  data: TopFiles[] | TopChannels[] | TopUsers[];
  title: string;
}

const Table = ({ columns, data, title }: PROPS): JSX.Element => {

  function documentFormatter(cell, row) {
    return (
      <div style={{wordWrap:'break-word'}}>
       { cell }
      </div>
    );
  }

  const tableColumns = columns.map((c) => {
    return {
      dataField: c.value,
      text: c.title,
      headerAlign: 'center',
      align: 'center',
      sort: true,
      formatter:documentFormatter
    };
  });

  let columnsSize: GridSize;

  if (columns.length === 3) {
    columnsSize = 4;
  } else if (columns.length === 2) {
    columnsSize = 6;
  } else {
    columnsSize = 3;
  }

  const pagination = paginationFactory({
    sizePerPage:parseInt(localStorage.getItem(title) || '', 10) || 10,
    onSizePerPageChange: (sizePage) => {
      sizePerPageTableChange(sizePage)
  }});

  const sizePerPageTableChange = (sizePerPage: number) =>{
    localStorage.setItem(title,sizePerPage.toString())
  }

  return (
    <div>
      {data.length > 0 ? (
        <BootstrapTable
          keyField={`${tableColumns[0].dataField}_${tableColumns[1].dataField}`}
          data={data}
          columns={tableColumns}
          striped
          hover
          condensed
          pagination={data.length > 10 ? pagination : undefined}
        />
      ) : (
        <Grid container spacing={0}>
          <Grid container>
            {columns.map((col) => (
              <Grid item xs={columnsSize} key={`${col.value}/${Math.random()}`}>
                <div className="skeleton-header">{col.title}</div>
              </Grid>
            ))}
          </Grid>
          <Grid
            container
            style={{
              border: '1px solid #dee2e6',
            }}
          >
            {columns.map((item, i) => (
              <Grid item xs={4} key={Math.random()}>
                <div style={{ textAlign: 'center' }} className="skeleton-footer">
                  {i === 1 && 'No Data Available'}
                </div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default Table;
